import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import NavTabs from './NavTabs';
import GlobalNav from './GlobalNav';
import UserProps from '../proptypes/user';
import { NAV_LOGO } from '../fragno1/navLogo';
import Alerts from '../containers/Alerts';

const NavBar = ({ isLoggedIn, navLogo, user }) => {
  return (
    <Fragment>
      {!!isLoggedIn && <Alerts />}
      <GlobalNav navLogo={navLogo} user={user} />
      <NavTabs isLoggedIn={isLoggedIn} />
    </Fragment>
  );
};

NavBar.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  navLogo: PropTypes.oneOf(Object.values(NAV_LOGO)),
  user: UserProps.isRequired,
};

NavBar.defaultProps = {
  navLogo: null,
};

export default NavBar;
